
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/37cb603fe6f888fc4eccfb549fcd2cba/b0e3db6063b1faa95b4b7b4b71a4b372.png" 
              alt="My Marketing Horizon Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Expanding your marketing reach with data-driven advertising campaigns across Google, social media, and native platforms.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-orange-500 transition-colors cursor-pointer">Google Ads</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors cursor-pointer">Social Media Ads</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors cursor-pointer">Native Advertising</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors cursor-pointer">Analytics & Optimization</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-300">
              <li>contact@my-marketinghorizon.com</li>
              <li>50 Princes Street<br />Ipswich, IP1 1RJ</li>
              <li>Company No: 16646875</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 mb-4 md:mb-0">&copy; {currentYear} MY MARKETING HORIZON LIMITED. All rights reserved.</p>
          <div className="flex space-x-6">
            <Link 
              to="/legal" 
              className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer text-sm"
            >
              Legal Information
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
